export type ElevarPriceTable = {
    tables?: ReadonlyArray<{
        type?: string | null;
        rows?: ReadonlyArray<{
            rowType?: string | null;
            amount?: number | null;
        } | null> | null;
    } | null> | null;
} | null;

export type ElevarPriceTableItemAmounts = {
    price?: number;
    compare_at_price?: number;
};

export const getElevarPriceTableItemAmounts = (
    priceTables: ElevarPriceTable | undefined
): ElevarPriceTableItemAmounts => {
    const rows = priceTables?.tables?.find(table => table?.type === 'MAIN')?.rows || [];
    const price = rows.find(row => row?.rowType === 'PRICE')?.amount;
    const listPrice = rows.find(row => row?.rowType === 'LIST_PRICE')?.amount;
    const soldPrice = typeof price === 'number' ? price : listPrice;
    return {
        ...(typeof soldPrice === 'number' ? { price: soldPrice } : {}),
        ...(typeof listPrice === 'number' ? { compare_at_price: listPrice } : {}),
    };
};
